import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniabusonrentinnashik() {



    const cardData =
    {
        keyword: 'Urbania Bus On Rent in Nashik',
        heading: 'Urbania on rent in pune: Urbania Bus On Rent in Nashik',
        headingDescription: 'Urbania On Rent in Pune offers premium and dependable Urbania Bus On Rent in Nashik for corporate groups, families, tourists, and event travelers planning comfortable group travel to and from Nashik. Our well-maintained Force Urbania bus fleet provides spacious seating, powerful air-conditioning, and smooth performance, making it ideal for long-distance journeys, airport transfers, corporate outings, weddings, sightseeing tours, and outstation trips between Pune and Nashik. With professional chauffeurs, flexible one-way and round-trip rental options, and convenient doorstep pickup from major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a safe, punctual, and stress-free travel experience. Backed by 24/7 booking support, transparent pricing, and trusted service, Urbania On Rent in Pune stands out as the trusted choice for Urbania bus hire in Nashik.',

        top: 'Top Places to Visit in Nashik with Pune on rent in pune',


"topPlaces": [
  {
    "title": "Trimbakeshwar Jyotirlinga Temple",
    "description": "Trimbakeshwar Temple is one of the twelve Jyotirlingas of Lord Shiva and the most sacred pilgrimage site near Nashik. Located at the origin of the Godavari River, the temple is unique for its three-faced lingam representing Brahma, Vishnu, and Mahesh. Built in classic black stone architecture, it attracts devotees throughout the year, especially during Mahashivratri and Kumbh Mela. Rituals like Narayan Nagbali and Kaal Sarp Puja are widely performed here, making it a major spiritual center."
  },
  {
    "title": "Panchavati",
    "description": "Panchavati is a holy area associated with the Ramayana, believed to be the place where Lord Rama, Sita, and Lakshmana lived during their exile. The region includes sacred spots like Sita Gufa, Ram Kund, and Kapaleshwar Temple. Pilgrims gather here to perform religious rituals and holy baths in the Godavari River. The spiritual vibrations, ancient temples, and mythological importance make Panchavati the soul of Nashik."
  },
  {
    "title": "Ram Kund",
    "description": "Ram Kund is the most sacred bathing ghat on the banks of the Godavari River in Nashik. It is believed that Lord Rama bathed here, and devotees consider a dip in the kund as spiritually purifying. During Kumbh Mela, millions gather at Ram Kund for holy baths. The surrounding temples, chants, and rituals create a deeply spiritual and devotional atmosphere."
  },
  {
    "title": "Sita Gufa",
    "description": "Sita Gufa is a small cave believed to be the place where Sita resided during the Ramayana period. It also marks the spot from where Ravana is said to have abducted Sita. Inside the cave, idols of Lord Rama, Sita, and Lakshmana are worshipped. The site holds immense mythological and spiritual significance for devotees and history enthusiasts."
  },
  {
    "title": "Kalaram Temple",
    "description": "Kalaram Temple is one of the most important temples in Nashik, dedicated to Lord Rama. Built using black stone, the temple derives its name from the black-colored idol of Lord Rama. It played a key role in India’s social reform movement, as Dr. B.R. Ambedkar led the Kalaram Temple Entry Movement here. The temple stands as a symbol of devotion, equality, and cultural heritage."
  },
  {
    "title": "Pandav Leni (Pandav Caves)",
    "description": "Pandav Leni is a group of ancient rock-cut caves dating back to the 1st century BCE. These Buddhist caves feature inscriptions, prayer halls, and monasteries carved into the Trirashmi Hills. The hilltop location offers panoramic views of Nashik city. The caves provide a blend of history, architecture, and tranquility, making them a popular spot for tourists and history lovers."
  },
  {
    "title": "Sula Vineyards",
    "description": "Sula Vineyards is India’s most famous wine tourism destination, located on the outskirts of Nashik. Visitors can explore vineyards, wine-making facilities, tasting rooms, and restaurants overlooking scenic hills and lakes. The vineyard hosts wine festivals and cultural events, attracting travelers from across the country. It adds a modern lifestyle touch to Nashik’s traditional spiritual identity."
  },
  {
    "title": "Anjneri Hills",
    "description": "Anjneri Hills is believed to be the birthplace of Lord Hanuman and is a popular trekking and nature destination near Nashik. Surrounded by lush greenery, waterfalls, and scenic landscapes, it offers a peaceful escape from the city. Trekkers, pilgrims, and nature lovers visit this site for adventure, spirituality, and panoramic hilltop views."
  },
  {
    "title": "Coin Museum (Indian Institute of Research in Numismatic Studies)",
    "description": "The Coin Museum in Nashik is the only museum in India dedicated entirely to numismatics. It displays ancient, medieval, and modern coins, currency notes, and minting techniques. The museum provides educational insights into India’s economic and historical evolution, making it a unique attraction for students, researchers, and history enthusiasts."
  },
  {
    "title": "Godavari Ghat",
    "description": "Godavari Ghat is a peaceful riverfront stretch along the Godavari River, used for religious rituals, evening aartis, and meditation. The ghats come alive during festivals and Kumbh Mela, reflecting Nashik’s deep spiritual roots. Visitors enjoy walking along the river, watching rituals, and experiencing the city’s sacred atmosphere."
  }
],




"services": [
{
"name": "Urbania Bus on Rent in Nashik",
"description": "Urbania Bus on Rent in Nashik provides comfortable and reliable Urbania buses for local travel, sightseeing, and long-distance journeys. The service is suitable for families, tourists, and groups looking for spacious seating, clean interiors, and a smooth travel experience within Nashik and beyond."
},
{
"name": "Nashik Urbania Bus Hire",
"description": "Nashik Urbania Bus Hire offers flexible bus hire solutions for city travel, outstation trips, and group transportation. With professional chauffeurs and well-maintained buses, this service ensures safe, timely, and hassle-free travel."
},
{
"name": "Urbania Rental Service Nashik",
"description": "Urbania Rental Service Nashik provides customized rental packages for daily use, tours, and multi-day travel. Designed to meet diverse travel needs, the service focuses on comfort, safety, and dependable transportation."
},
{
"name": "Urbania AC Bus on Rent Nashik",
"description": "Urbania AC Bus on Rent Nashik offers fully air-conditioned Urbania buses for a relaxed and climate-controlled journey. Ideal for long routes and group travel, these buses ensure comfort even during extended travel hours."
},
{
"name": "Corporate Urbania Hire Nashik",
"description": "Corporate Urbania Hire Nashik delivers professional transport solutions for corporate meetings, team outings, and business travel. With punctual service, comfortable interiors, and trained drivers, it supports smooth corporate mobility."
},
{
"name": "Urbania for Outstation Nashik",
"description": "Urbania for Outstation Nashik provides dependable buses for travel from Nashik to nearby cities and tourist destinations. Designed for long-distance journeys, the service ensures comfort, safety, and reliable performance."
},
{
"name": "Urbania Airport Transfer Nashik",
"description": "Urbania Airport Transfer Nashik offers timely and comfortable airport pickup and drop services. With ample luggage space and professional drivers, it ensures stress-free transfers for individuals and groups."
},
{
"name": "Luxury Urbania Nashik",
"description": "Luxury Urbania Nashik delivers a premium travel experience with modern interiors, plush seating, and superior comfort. Ideal for VIP travel, special occasions, and luxury tours."
},
{
"name": "Affordable Urbania Hire Nashik",
"description": "Affordable Urbania Hire Nashik provides budget-friendly Urbania bus rental options without compromising on comfort or safety, making it suitable for cost-conscious travelers and group trips."
},
{
"name": "Chauffeur Driven Urbania Nashik",
"description": "Chauffeur Driven Urbania Nashik ensures a relaxed and stress-free journey with skilled, verified drivers who are experienced with local and outstation routes."
},
{
"name": "Urbania for Wedding Events Nashik",
"description": "Urbania for Wedding Events Nashik offers elegant and reliable transportation for wedding guests, family members, and event-related travel, ensuring smooth coordination and comfortable journeys."
},
{
"name": "Urbania for Corporate Travel Nashik",
"description": "Urbania for Corporate Travel Nashik provides organized and punctual transportation for corporate staff, clients, and business events, focusing on professionalism and reliability."
},
{
"name": "Best Urbania Rental Nashik",
"description": "Best Urbania Rental Nashik is known for top-quality buses, consistent service standards, and customer satisfaction, making it a preferred choice for Urbania rentals in Nashik."
},
{
"name": "Urbania Group Travel Nashik",
"description": "Urbania Group Travel Nashik offers spacious and well-managed transport solutions for group outings, tours, and events, ensuring everyone travels together comfortably."
},
{
"name": "Reliable Urbania Hire Nashik",
"description": "Reliable Urbania Hire Nashik delivers dependable and safe transportation services with a strong focus on punctuality, vehicle quality, and customer support."
}
],
"tableData": [
["Urbania Bus on Rent in Nashik", "Nashik Urbania Bus Hire"],
["Urbania Rental Service Nashik", "Urbania AC Bus on Rent Nashik"],
["Corporate Urbania Hire Nashik", "Urbania for Outstation Nashik"],
["Urbania Airport Transfer Nashik", "Luxury Urbania Nashik"],
["Affordable Urbania Hire Nashik", "Chauffeur Driven Urbania Nashik"],
["Urbania for Wedding Events Nashik", "Urbania for Corporate Travel Nashik"],
["Best Urbania Rental Nashik", "Urbania Group Travel Nashik"],
["Reliable Urbania Hire Nashik", ""]
],



whychoose : [
    {
        "WhyChooseheading": "Urbania Bus On Rent in Nashik for Comfortable Travel",
        "WhyChoosedescription": "Urbania Bus On Rent in Nashik is ideal for local sightseeing, outstation trips, group travel, family outings, corporate tours, and pilgrimage journeys, ensuring a comfortable and smooth ride."
    },
    {
        "WhyChooseheading": "Spacious and Modern Urbania Buses",
        "WhyChoosedescription": "Our Urbania buses in Nashik are equipped with air-conditioning, ample legroom, comfortable reclining seats, and sufficient luggage space for a pleasant travel experience."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "All drivers are trained, licensed, and experienced in handling Nashik city routes and nearby outstation destinations, ensuring safe and stress-free travel."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Urbania Bus On Rent in Nashik offers competitive pricing with no hidden charges, making group and tourist travel cost-effective."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "We provide round-the-clock booking assistance and dedicated customer support for inquiries, reservations, and last-minute travel needs."
    },
    {
        "WhyChooseheading": "Flexible Travel Packages",
        "WhyChoosedescription": "Available for local tours, outstation trips, multi-day journeys, corporate outings, and customized travel plans as per your requirements."
    },
    {
        "WhyChooseheading": "Clean and Well-Maintained Vehicles",
        "WhyChoosedescription": "All Urbania buses are regularly cleaned, sanitized, and well-maintained to ensure passenger comfort and safety."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Our Urbania Bus On Rent in Nashik guarantees on-time pickups, reliable service, and a smooth overall travel experience."
    }
]
}
const faqData = [
    {
        question: 'Can Urbania Bus On Rent in Nashik be booked for outstation travel?',
        answer: 'Yes, it can be booked for outstation trips, sightseeing tours, family vacations, corporate travel, and group journeys.'
    },
    {
        question: 'How can I book Urbania Bus On Rent in Nashik?',
        answer: 'Bookings can be made via phone, WhatsApp, or online for quick and convenient reservations.'
    },
    {
        question: 'Why choose Urbania Bus On Rent in Nashik?',
        answer: 'This service offers spacious seating, professional drivers, clean vehicles, flexible travel packages, and transparent pricing.'
    },
    {
        question: 'Are the drivers experienced with Nashik routes?',
        answer: 'Yes, all drivers are experienced and familiar with Nashik city routes and popular nearby destinations.'
    },
    {
        question: 'Can pickup and drop locations be customized?',
        answer: 'Absolutely. Flexible pickup and drop-off locations are available across Nashik and nearby areas.'
    },
    {
        question: 'Is Urbania Bus On Rent in Nashik available 24/7?',
        answer: 'Yes, booking and customer support services are available 24/7.'
    },
    {
        question: 'Are hygiene and safety standards maintained?',
        answer: 'Yes, all buses are thoroughly cleaned, sanitized, and well-maintained for passenger safety.'
    },
    {
        question: 'What payment options are accepted?',
        answer: 'Payments can be made via UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing.'
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout the journey.'
    },
    {
        question: 'Is this service suitable for families and corporate groups?',
        answer: 'Yes, Urbania Bus On Rent in Nashik is perfect for families, corporate groups, tourists, and large travel groups.'
    }
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Prashant Joshi',
        feedback: 'We hired an Urbania bus in Nashik for a family function. The bus was clean, spacious, and the journey was very comfortable.',
        rating: 5
    },
    {
        id: 2,
        name: 'Ms. Neha Kulkarni',
        feedback: 'Professional service and punctual pickup. Urbania Bus On Rent in Nashik made our group trip smooth and enjoyable.',
        rating: 5
    }
];







































































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania Bus On Rent in Nashik",
  "image": "https://urbaniaonrentpune.in/assets/images/urbania-bus-nashik.jpg",
  "description": "Urbania Bus on Rent in Nashik offers AC Urbania buses for one-way or round-trip travel, corporate trips, family tours, airport transfers, and group travel. Chauffeur-driven Urbania buses ensure safe, comfortable, and convenient transportation in and around Nashik.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "15000",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/urbania-bus-on-rent-nashik"
  }
};






    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Urbania Bus On Rent in Nashik | AC Urbania Bus for Tours & Travel 
  </title>

  <meta
    name="description"
    content="Book Urbania Bus on Rent in Nashik for one-way or round-trip travel, corporate trips, family tours, airport transfers, and group travel. AC Urbania buses with chauffeur-driven service provide safe, comfortable, and convenient transportation in and around Nashik."
  />

  <meta
    name="keywords"
    content="Urbania Bus on Rent in Nashik, Nashik Urbania Bus Hire, Urbania Rental Service Nashik, Urbania AC Bus on Rent Nashik, Corporate Urbania Hire Nashik, Urbania for Outstation Nashik, Urbania Airport Transfer Nashik, Luxury Urbania Nashik, Affordable Urbania Hire Nashik, Chauffeur Driven Urbania Nashik, Urbania for Wedding Events Nashik, Urbania for Corporate Travel Nashik, Best Urbania Rental Nashik, Urbania Group Travel Nashik, Reliable Urbania Hire Nashik"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/84.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniabusonrentinnashik;